/**
 * EntityLink — inline entity navigation link.
 * Promoted from features/communication-v2/components/EntityLink.tsx for app-wide reuse (T2).
 * Caller provides onActivate (the navigate callback).
 * Calls e.stopPropagation() so cell-link clicks don't double-fire a parent row-click.
 * [Source: ui-from-v0 components/brokly/entity-link.tsx (stopPropagation)]
 * [Source: apps/web/src/features/communication-v2/components/EntityLink.tsx]
 */
import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface EntityLinkProps {
  children: ReactNode;
  onActivate?: () => void;
  className?: string;
  /** Tooltip — for a link whose destination is not obvious from its text alone. */
  title?: string;
}

export function EntityLink({ children, onActivate, className, title }: EntityLinkProps) {
  return (
    <button
      type="button"
      title={title}
      onClick={(e) => {
        e.stopPropagation();
        onActivate?.();
      }}
      className={cn(
        'inline-flex items-center gap-1 text-sm font-medium text-sem-info underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className,
      )}
    >
      {children}
    </button>
  );
}
